import React, { useCallback, useEffect, useState } from "react";
import { BsChatSquareDotsFill, BsThreeDotsVertical } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa";
import { IoBagHandleOutline } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";
import { useLocation } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const BASE_URL = API_BASE_URL;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const PostList = () => {
  const products = [
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
  ];
   const q = useQuery();
  const sellerId = q.get("sellerId"); // expects /shpebuye?sellerId=ID
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [commentsByPost, setCommentsByPost] = useState({});
  const [openCommentsFor, setOpenCommentsFor] = useState(null);

   const fetchSellerPosts = useCallback(async () => {
    if (loading || !hasMore) return;
    if (!sellerId) {
      setError("Seller not specified");
      return;
    }

    setLoading(true);
    setError(null);

    const token =
      sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }

    const requestBody = {
      filters: {
        seller_id: Number(sellerId),
        is_seller_post: true,
      },
      page,
      limit: 10,
    };

    try {
      const response = await fetch(`${BASE_URL}/post/get-posts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (response.ok && data.success) {
        const newPosts = Array.isArray(data.result?.posts) ? data.result.posts : [];
        setPosts((prev) => {
          const existingIds = new Set(prev.map((p) => p.id));
          const filtered = newPosts.filter((p) => !existingIds.has(p.id));
          return [...prev, ...filtered];
        });
        setHasMore(newPosts.length === 10);
        setPage((p) => p + 1);
      } else {
        setError(data?.message || "Failed to fetch posts.");
      }
    } catch (err) {
      console.error("❌ Error fetching posts:", err);
      setError("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  }, [page, hasMore, loading, sellerId]);


   const fetchComments = async (postId) => {
    const token =
      sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      console.warn("token missing for comments");
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/comment/get-comments`, {
        method: "POST",
        headers: { "Content-Type": "application/json", token },
        body: JSON.stringify({
          filters: { post_id: String(postId) },
          page: 1,
          limit: 50,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setCommentsByPost((prev) => ({ ...prev, [postId]: data.result?.comments || [] }));
      } else {
        console.warn("Failed to fetch comments:", data.message);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
    }
  };

  useEffect(() => {
    // reset when sellerId changes
    setPosts([]);
    setPage(1);
    setHasMore(true);
    setError(null);
    setCommentsByPost({});
  }, [sellerId]);

  useEffect(() => {
    // initial load
    if (sellerId) fetchSellerPosts();
  }, [sellerId]); // eslint-disable-line

  return (
    <div className="flex flex-col lg:flex-row items-start mt-8 lg:mt-20 w-[100%] gap-6 lg:gap-10">
      {" "}
      <div className="w-full lg:w-[70%] bg-[#FFFEEB] rounded-xl p-4 shadow-md space-y-4 border border-[#ccc]">
        {error && <div className="text-red-600 p-2">{error}</div>}

        {posts.length === 0 && !loading && <div className="p-4">No posts found.</div>}

        {posts.map((post) => (
          <div key={post.id} className="border-b py-4">
            <div className="flex justify-between ">
              <div className="flex items-center gap-3">
                <img
                  src={post.user?.profile_picture_url || require("../../assets/profile.png")}
                  alt={post.user?.first_name || "user"}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-sm">
                    {post.user?.first_name ? `${post.user.first_name} ${post.user.last_name || ""}`.trim() : post.user?.username}
                  </p>
                  <p className="text-xs text-gray-500">{new Date(post.created_at).toLocaleString()}</p>
                </div>
              </div>
              <button className="text-gray-400 text-xl font-bold">
                <BsThreeDotsVertical />
              </button>
            </div>

            {post.title && <h3 className="font-semibold mt-2">{post.title}</h3>}

            <p className="text-gray-700 text-sm mt-2 whitespace-pre-wrap">{post.content}</p>

            {/* media */}
            {Array.isArray(post.media_url) && post.media_url.length > 0 && (
              <div className="flex gap-2 overflow-x-auto mt-3">
                {post.media_url.map((m, idx) => (
                  <img
                    key={idx}
                    src={m.url}
                    alt={`media-${idx}`}
                    className="w-32 h-32 border-2 rounded-lg object-cover flex-shrink-0"
                  />
                ))}
              </div>
            )}

           

            {/* tags */}
            {Array.isArray(post.tags) && post.tags.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-2">
                {post.tags.map((tag, i) => (
                  <span key={i} className="bg-[#d5f7e4] text-green-800 text-xs font-medium px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            )}

            <div className="flex justify-between items-center pt-2">
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <div className="flex items-center gap-2 bg-gray-600 px-2 py-[5px] rounded-xl text-white">
                  <BsChatSquareDotsFill />
                  <span>{post.likeCount || 0}</span>
                </div>
                <div className="flex items-center gap-1">
                  {/* <FaRegEye className="text-gray-500 text-xl" /> */}
                  {/* <span>{post.viewCount || `${post.commentCount || 0} Views`}</span> */}
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button className="">
                  <img
                    src="/image/sharebuttoncontainer.png"
                    alt="share"
                    className="w-[110px] h-[35px]"
                  />
                </button>

                {/* <button
                  onClick={() => {
                    if (!commentsByPost[post.id]) fetchComments(post.id);
                    setOpenCommentsFor((prev) => (prev === post.id ? null : post.id));
                  }}
                  className="text-sm text-gray-700 px-3 py-1 border rounded"
                >
                  Comments ({post.commentCount || 0})
                </button> */}
              </div>
            </div>

            {/* comments */}
            {openCommentsFor === post.id && (
              <div className="mt-3 bg-white p-3 rounded shadow-inner">
                {commentsByPost[post.id] && commentsByPost[post.id].length > 0 ? (
                  commentsByPost[post.id].map((c) => (
                    <div key={c.id || `${c.user?.id}-${Math.random()}`} className="mb-2">
                      <div className="flex items-center gap-2">
                        <img src={c.user?.profile_picture_url || require("../../assets/profile.png")} className="w-8 h-8 rounded-full object-cover" alt="cuser" />
                        <div>
                          <div className="text-sm font-semibold">{c.user?.first_name || c.user?.username}</div>
                          <div className="text-xs text-gray-600">{c.comment}</div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-sm text-gray-500">No comments yet.</div>
                )}
              </div>
            )}
          </div>
        ))}

        <div className="mt-4 flex justify-center">
          {loading ? (
            <button className="px-4 py-2 bg-gray-300 rounded">Loading...</button>
          ) : hasMore ? (
            <button onClick={fetchSellerPosts} className="px-4 py-2 bg-green-600 text-white rounded">
              Load more
            </button>
          ) : (
            <div className="text-gray-500">No more posts</div>
          )}
        </div>
      </div>
      {/* <div className="w-full lg:w-[30%] bg-gray-200 rounded-lg p-5 shadow-xl">
        <div>
          <div className="max-w-sm rounded-2xl overflow-hidden bg-gradient-to-br from-blue-200 to-teal-300 p-6 shadow-md relative text-slate-800">
            <h2 className="text-xl font-semibold mb-2">
              Summer headphones
              <br />
              from top brands
            </h2>
            <button className="mt-7 gap-2 flex items-center text-blue-900 font-medium hover:underline">
              Buy it now
              <FaArrowRight />
            </button>

            <div className="absolute right-4 bottom-4 flex  items-center">
              <img
                src="/image/headphone.png"
                alt="Red Headphones"
                className="h-20 relative left-5"
              />
              <img
                src="/image/eyephone.png"
                alt="Green Earbuds"
                className="h-20 z-10"
              />
            </div>
          </div>
          <p className="py-4 text-center">Best matching products for you</p>
        </div>
        <div>
          {products.map((product, index) => (
            <div className=" p-2">
              <div className="relative bg-[#FAFAFA] shadow-md rounded-md">
                <div className="w-full h-[170px] object-contain">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>

                {product.offer && (
                  <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
                    {product.offer}
                  </span>
                )}
              </div>

              <p className="mt-4 text-sm text-gray-600 uppercase">
                {product.name}
              </p>

              <div className="flex flex-row  justify-between ">
                <div className="flex flex-col">
                  <span className="line-through text-gray-400 text-sm">
                    ${product.originalPrice}
                  </span>
                  <span className="text-black font-semibold">
                    ${product.discountPrice}
                  </span>
                </div>
                <button className="mt-3 flex shrink-0 whitespace-nowrap py-2 px-3 text-sm md:text-[16px] gap-2 md:gap-4 items-center  bg-gray-900 text-white  rounded-full  ">
                  <IoBagHandleOutline className="text-lg" />
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default PostList;
